<div class="pb-0">
  <app-nav-menu #navMenu [userName]='userName' [email]='email' [currentCustomer]='currentCustomer'
    [activeLink]='activeLink' (companySelectionModalOutput)='companyModalSelectionModal($event)'
    (changedCustomerEmitter)='receiveCustomer($event)'
    (showDataScopeSelectionOutput)="changeShowDataScopeSelection($event)" (navigateToOutput)='navigateToPage($event)'>
  </app-nav-menu>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<div class="pt-5">
  <app-footer #footer [lastLogonDate]='lastLogonDate'></app-footer>
</div>
<app-customer-selector #customerSelector [customers]='customers' (currentCustomer)="receiveCustomer($event)"
  *ngIf="customers?.length > 1"></app-customer-selector>
<div style="visibility:hidden">
  <app-company-datascope-selector #companyDataScopeSelector [customers]='customers'
    (currentCustomer)="receiveCustomer($event)" [companyDialogVisible]="companyDialogVisible"
    [showDataScopeSelection]="showDataScopeSelection" (companySelectionModalOutput)='companyModalSelectionModal($event)'
    [navigateToInput]="navigateTo"></app-company-datascope-selector>
</div>


<div style="visibility:hidden">
  <ejs-dialog #sessionTimeoutModal id="sessionTimeoutModal" [isModal]='isModal' [animationSettings]='animationSettings'
    [closeOnEscape]='false' [showCloseIcon]='false' [width]='modalWidth' [position]='position' [visible]='hidden'
    [height]='modalHeight' [buttons]='dlgButtons' (click)="dialogClicked($event)" (overlayClick)="onOverlayClick()">

    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white"> Session Expiring</h3>
      </div>
      <div class="card-body">
        <p>
          Your session will expire in <strong>{{ sessionExpireSecondsLeft + 1 | number : '1.0-0' }}</strong> seconds.
        </p>
      </div>
    </div>
  </ejs-dialog>
</div>
<div style="visibility:hidden">
  <ejs-dialog #absoluteSessionTimeoutModal id="absoluteSessionTimeoutModal" [isModal]='isModal'
    [animationSettings]='animationSettings' [closeOnEscape]='false' [showCloseIcon]='false' [width]='modalWidth'
    [position]='position' [visible]='hidden' [height]='modalHeight' [buttons]='dlgAbsoluteSessionTimeoutButtons'
    (click)="dialogClicked($event)" (overlayClick)="onOverlayClick()">

    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white"> Absolute Session Expiring</h3>
      </div>
      <div class="card-body">
        <p>
          Your session will expire in <strong>{{ absoluteSessionExpireMinutesLeft | number : '1.0-0' }}</strong>
          minutes.
        </p>
        <p>
          Please save your work and re-login to continue using the application.
        </p>
      </div>
    </div>
  </ejs-dialog>
</div>

<div *ngIf="loading" class="col-lg-12">
  <div id="loading"></div>
</div>